<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="apply-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="destroyElement ()"></div>
                <div class="dialog-wrapper">
                    <div class="t-apply"></div>

                    <div class="msg-view">
                        <div class="text">
                            <p>确认接受【 <b>{{ player_data.nickName }}</b>】的回归招募邀请。</p>
                            <p>活动期间，只能接受一个邀请。</p>
                        </div>
                    </div>
                    
                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="destroyElement ()"></div>  
                        <div class="u-btn ok" @click="apply"></div>                                                                 
                    </div>

                    <div class="apply-text">
                        <h5>执笔绘春 新章启序</h5>
                        <p>新换装、新地图、新成就、新体验、新成长……</p>
                        <p>春宴万象更新，静待您来体验</p>
                    </div>

                    <div class="img"></div>                   
                </div>
            </div>            
        </div>

        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
@include responseTo("desktop"){
    .apply-modal{
        transform: scale(0.8);
    }

}

.apply-modal{
    position: relative;
    width: 641px;
    height: 644px;
    background-image: url(~@/assets/images/modal/bg-modal-invite_apply_team.png);    
}

.t-apply{
    width: 337px;
    height: 42px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/modal/title-invite_apply_team.png);
}

.msg-view{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    text-align: center;
    margin: 0 auto 0;
    padding: 0 24px 0;
    line-height: 1.6;    
    color: #3b3f3e;

    font-size: 22px;

    b{
        color: #5b734f;
    }
}

.notice{
    margin-top: 22px;
    text-align: center;
    color: #5b734f;
}

.warn{
    font-size: 22px;
    text-align: center;
    color: #de482b;
}

.u-ctrl{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    padding: 0 20px;
    gap: 30px;
}

.u-btn.ok{
    width: 214px;
    height: 59px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-ok.png);    
}

.u-ctrl .u-btn.cancel{
    width: 214px;
    height: 59px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

.apply-text{
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;

    h5{
        margin-bottom: 10px;
        font-size: 26px;
        color: #5b734f;
    }
}

.img{
    width: 552px;
    height: 233px;
    margin: 0 auto;
    background-image: url(~@/assets/images/modal/img-apply.png); 
}
</style>

<script>
import { apiInviteApply , apiInviteInfo } from '@/api/index';

export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            text : '请稍后再试', 
            error : true,
            tid : 0,
            type : 1,
            ready : false,
            fromType : 1,//1绑定码 2口令码    
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    mounted(){
        this.render();
    },
    methods : {
        destroyElement () {
            this.$destroy()
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },
        render() {
            var _this = this;
            apiInviteInfo({code : this.code}).then(
                res => {
                    this.player_data = res.data;
                },
                rej => {
                    this.error_text = rej.message || '请稍后再试';
                    this.$toast(rej.message);
                    this.$store.commit("$_setShare", '');
                    localStorage.setItem('share', '');                      
                },
            );
        },        
        apply (){

            if(!this.$store.state.login){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.destroyElement();
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            this.apply_team();
        },
        apply_team (){
            apiInviteApply({ code : this.code }).then(
                res => {
                    this.destroyElement();
                    this.$game_modal()
                    this.$store.commit("$_setShare", '');
                    localStorage.setItem('share', '');                    
                },
                rej => {
                    this.destroyElement();
                    let error = rej.code == 404 ? '该用户累计加入次数已达上限' : rej.message;
                    this.$toast(error);
                    //this.$msg_modal({text : rej.message});
                    
                    this.$store.commit("$_setShare", '');
                    localStorage.setItem('share', '');                         
                },
            );
        },                
    },
}
</script>